import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion';
import './About.scss';
import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
const About = () => {
    const [abouts, setAbouts] = useState([]);
    useEffect(() => {
        const query = '*[_type == "abouts"]';
        client.fetch(query)
            .then((data) => setAbouts(data));
    }, []);

    return (
        <>
            <h2 className="head-text">
                I’m a <span>designer</span> who <span>codes</span>,<br />
                with 2+ Years of <span>Experience</span>
            </h2>
            <p className="app__flex p-text" style={{ marginTop: 10 }}>
                I’ve worked remotely on projects for leading brands, and startups.<br/>
                I care about creating world-class, and useful products that help people and make a difference.<br/>
                I can be as involved in your project as you need me to be, from the seed of the idea,<br/> creative direction, web development, graphic design, and even the back-end development.
            </p>
            <div className="app__profiles">
                {abouts.map((about, index) => (
                    <motion.div
                        whileInView={{ opacity: 1 }}
                        whileHover={{ scale: 1.1 }}
                        transition={{ duration: 0.5, type: 'tween' }}
                        className="app__profile-item"
                        key={about.title + index}
                    >
                        <img src={urlFor(about.imgUrl)} alt={about.title} />
                        <h2 className="bold-text" style={{ marginTop: 20 }}>
                            {about.title}
                        </h2>
                        <p className="p-text" style={{ marginTop: 10 }}>
                            {about.description}
                        </p>
                    </motion.div>
                )
                )}
            </div>
        </>
    )
}

export default AppWrap(
    MotionWrap(About, 'app__about'),
    'about',
    'app__whitebg',
);